import Vue from 'vue'
import axios from 'axios'
let baseURL = 'https://www.rakumart-2c.com:8080/api/client'
let token = localStorage.getItem('token')
import qs from 'qs'
// 商品列表
// export const clientOrderList = (data) => Vue.prototype.postAxios(baseURL + "/clientOrderList?token=" + token, data)
export const clientOrderList = (data) => axios({
    url: baseURL + "/clientOrderList?token=" + token,
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 备注
export const updateClientRemark = (data) => axios({
    url: baseURL + "/updateClientRemark?token=" + token,
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 修改地址
export const updateOrderAddress = (data) => axios({
    url: baseURL + "/updateOrderAddress?token=" + token,
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 修改配送方式
export const forbid_pordno = (data) => axios({
    url: baseURL + "/forbid_pordno?token=" + token,
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 状态列表
export const clientOrderListTab = (data) => Vue.prototype.postAxios(baseURL + "/clientOrderListTab?token=" + token, data)

// 备注修改
export const updateRemark = (data) => Vue.prototype.postAxios(baseURL + "/updateRemark?token=" + token, data)

// 修改配送方式
export const updateManageOrdno = (data) => axios({
    url: baseURL + "/updateManageOrdno?token=" + token,
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
